import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { operatorsApi } from '@/api/index';

export const fetchOperators = createAsyncThunk(
  'operators',
  async (params, thunkAPI) => {
    try {
      const response = await operatorsApi.getAll();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
